























































import Vue from 'vue';
import events from './events';
import { ToastMessage } from './models/message';

interface Params {
  message: ToastMessage;
  color: string;
  show: boolean;
}

export default Vue.extend({
  name: 'Toast',
  data() {
    return {
      show: false,
      color: '',
      data: {
        header: '',
        message: '',
      } as ToastMessage,
    };
  },
  mounted() {
    events.$on('show', (payload: Params) => {
      if (!Object.hasOwnProperty.call(payload, 'message')) {
        return;
      }
      this.data = payload.message;
      this.color = Object.hasOwnProperty.call(payload, 'color')
        ? payload.color : 'success';
      this.show = true;
    });

    events.$on('info', (msg: string) => {
      this.data.message = msg;
      this.color = 'blue';
      this.show = true;
    });

    events.$on('error', (msg: string) => {
      this.data.message = msg;
      this.color = '#B31412';
      this.show = true;
    });

    events.$on('warning', (msg: string) => {
      this.data.message = msg;
      this.color = 'orange';
      this.show = true;
    });

    events.$on('success', (msg: string) => {
      this.data.message = msg;
      this.color = 'green';
      this.show = true;
    });
  },
});
